import { IStyles } from '../models/app/IStyles';

export const STYLES: IStyles = {
	components: {
		app: {
			children: {
				wrapper: {
					overrides: [
						{
							selector: '.recharts-legend-wrapper',
							style: {
								padding: {
									left: '10px',
								},
							},
						},
						{
							selector: '.xpivot-label, .ypivot-label',
							style: {
								font: {
									weight: "bold",
									size: "18px"
								}
							}
						}
					],
				},
			},
		},
		customTooltip: {
			children: {
				wrapper: {
					background: {
						color: 'white',
					},
					box: {
						shadow: '0px 0px 1px rgba(0, 0, 0, 0.5), 0px 2px 4px rgba(0, 0, 0, 0.1);',
					},
					padding: {
						_value: '4px',
					},
				},
				header: {
					font: {
						weight: 'bold',
					},
				},
				item: {
				},
			},
		},
	},
	theme: {
		charting: {
			chartBase: {
				children: {
					wrapper: {
						height: '400px',
					},
				},
			},
		},
	},
};